import { Fragment } from 'react';
import { Box, List, ListItem, ListItemButton, ListItemText, IconButton, Chip, Tooltip, Typography } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RefreshIcon from '@mui/icons-material/Refresh';
import { notificationPath } from '../../utils/navigationUtils';

export default function NotificationList({ items = [], onMarkRead, onRefresh, onOpen }) {
  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" p={1} pl={2} pr={2}>
        <Typography variant="body2" color="text.secondary">
          {items.length} notification{items.length === 1 ? '' : 's'}
        </Typography>
        <Tooltip title="Refresh">
          <IconButton size="small" onClick={onRefresh}><RefreshIcon fontSize="small" /></IconButton>
        </Tooltip>
      </Box>

      <List disablePadding>
        {items.length === 0 && (
          <Box p={2}><Typography variant="body2" color="text.secondary">No notifications.</Typography></Box>
        )}
        {items.map(n => {
          // Only rows the API resolved a target for are clickable. Older
          // notifications — and any shape the reader doesn't recognise — stay
          // inert rather than navigating somewhere wrong.
          const canOpen = !!onOpen && !!notificationPath(n.target);

          const content = (
            <ListItemText
              primary={
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="subtitle2">{n.title}</Typography>
                  <Typography variant="caption" color="text.secondary">{new Date(n.createdAt).toLocaleString()}</Typography>
                </Box>
              }
              secondary={<Typography variant="body2">{n.body}</Typography>}
            />
          );

          return (
            <Fragment key={n.id}>
              <ListItem
                className="comm-list-item"
                disablePadding={canOpen}
                secondaryAction={
                  !n.read ? (
                    <Tooltip title="Mark as read">
                      <IconButton edge="end" onClick={() => onMarkRead(n.id)}>
                        <DoneAllIcon />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Chip size="small" label="Read" />
                  )
                }
              >
                {canOpen ? (
                  <ListItemButton onClick={() => onOpen(n)}>{content}</ListItemButton>
                ) : content}
              </ListItem>
            </Fragment>
          );
        })}
      </List>
    </Box>
  );
}
